import { otto } from "../chunks/common-nexus-client-BxVeVD8v.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const PREFIX = "tr-v1";
const tracking = /*           */ asExport(otto, PREFIX, {});
const onInit = /*           */ asExport(tracking, "onInit", {});
const lockInit = /*           */ asExport(tracking, "lockInit", noop);
const unlockInit = /*           */ asExport(
  tracking,
  "unlockInit",
  noop
);
export {
  PREFIX,
  lockInit,
  onInit,
  tracking,
  unlockInit
};
/*                                        */
